import { Injectable } from '@angular/core';
import { CommandHandlerResolver } from '../../../core/service/command/command-handler-resolver.service';
import { standardCommand } from '../../../core/model/command';
import { DeleteCommandHandler } from '../../../core/service/command/delete-command-handler.service';
import { EditCommandHandler } from '../../../core/service/command/edit-command-handler.service';
import { PreviewMailCommandHandler } from './preview-mail-command-handler.service';
import { SendMailCommandHandler } from './send-mail-command-handler.service';
import { mailCommand } from '../../model/const/command';

@Injectable()
export class MailCommandHandlerResolver extends CommandHandlerResolver {
  constructor(
    deleteHandler: DeleteCommandHandler,
    editHandler: EditCommandHandler,
    previewHandler: PreviewMailCommandHandler,
    sendHandler: SendMailCommandHandler
  ) {
    super();
    this.addHandler(standardCommand.delete, deleteHandler);
    this.addHandler(standardCommand.edit, editHandler);
    this.addHandler(mailCommand.preview, previewHandler);
    this.addHandler(mailCommand.send, sendHandler);
  }
}
